export const PLANS_NAME = {
  CLASSIC: "Classic",
  CORPORATE: "Corporate",
  FREE: "Free",
  BASIC: "Basic",
  BUSINESS: "Business"
}